import { __assign } from "tslib";
import * as React from 'react';
var isSimpleParams = function (simpleOrJSXParams) { return !Object.keys(simpleOrJSXParams).some(function (key) {
    return typeof simpleOrJSXParams[key] === 'function';
}); };
var getOnlyJsxParams = function (params) {
    return Object.keys(params).reduce(function (prev, paramName) {
        var _a;
        return typeof params[paramName] !== 'function' ? prev : __assign(__assign({}, prev), (_a = {}, _a[paramName] = params[paramName], _a));
    }, {});
};
var resolveSimpleParams = function (str, params) {
    return Object.keys(params).reduce(function (prev, paramName) {
        var param = params[paramName];
        var type = typeof param;
        switch (type) {
            case 'number':
            case 'string':
                var pattern = new RegExp("{{" + paramName + "}}", 'g');
                return prev.replace(pattern, param.toString());
            default:
                return prev;
        }
    }, str);
};
var resolveJSXParams = function (strParts, params) {
    return strParts.map(function (stringPart) {
        var contentTagMatch = stringPart.match(/^<(.+?)>(.*?)<\/.+?>$/);
        if (contentTagMatch && params[contentTagMatch[1]]) {
            return params[contentTagMatch[1]](contentTagMatch[2]);
        }
        var selfClosingTagMatch = stringPart.match(/^<(.+?)[ ]?\/>$/);
        if (selfClosingTagMatch && params[selfClosingTagMatch[1]]) {
            return params[selfClosingTagMatch[1]]('');
        }
        else {
            return React.createElement("span", null, stringPart);
        }
    });
};
export var resolveParams = function (str, params) {
    if (params === void 0) { params = {}; }
    var strWithResolvedSimpleParams = resolveSimpleParams(str, params);
    if (isSimpleParams(params)) {
        return strWithResolvedSimpleParams;
    }
    var jsxParams = getOnlyJsxParams(params);
    var jsxParamsRegex = new RegExp(Object.keys(jsxParams).map(function (key) { return "(<" + key + ">.*?</" + key + ">)|(<" + key + "[ ]?/>)"; }).join('|'), 'g');
    var stringPartsAndPlaceholdersArray = strWithResolvedSimpleParams.split(jsxParamsRegex).filter(function (s) { return !!s; }); // ['first part', '<tagName>inner text</tagName>', 'second part']
    var wrappedStringPartsAndElements = resolveJSXParams(stringPartsAndPlaceholdersArray, jsxParams); // [<span>first part</span>, <SomeJSXElement/>, <span>second part</span>]
    return React.createElement(React.Fragment, null, wrappedStringPartsAndElements);
};
export var createTranslateFn = function (sourceOrSourceProvider) {
    var sourceProvider = typeof sourceOrSourceProvider === 'function' ? sourceOrSourceProvider : function (key) { return sourceOrSourceProvider[key]; };
    var translateFn = function (key, params) {
        var str = sourceProvider(key) || key;
        return resolveParams(str, params);
    };
    return translateFn;
};
export var toBabelLocale = function (lang) {
    // As our simplified and traditional chinese will be "zh-Hans" and "zh-Hant" this is needed to properly transfor to what babel expects
    switch (lang) {
        case 'iw':
            // see #7007
            return 'he';
        case 'zh-Hans':
            return 'zh-CN';
        case 'zh-Hant':
            return 'zh-TW';
        default:
            return lang;
    }
};
//# sourceMappingURL=index.js.map